export const isPromise = <T>(promise: Promise<T>) => {
    return promise && typeof promise.then === 'function';
};